import React, { useRef, useState } from 'react';
import {
  Avatar,
  Box,
  ButtonBase,
} from '@mui/material';
import { UserCircle as UserCircleIcon } from '../../../icons/user-circle';
import { useAuth } from '../../../hooks/useAuth';
import AccountMenu from './AccountMenu';
import { style } from './style';

const Account = (): JSX.Element => {
  const { user } = useAuth();
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const handleOpenMenu = (): void => {
    setOpenMenu(true);
  };

  const handleCloseMenu = (): void => {
    setOpenMenu(false);
  };

  return (
    <>
      <Box
        component={ ButtonBase }
        sx={ style.box.sx }
        onClick={ handleOpenMenu }
        ref={ anchorRef }
      >
        <Avatar sx={ style.avatar.sx } src={ user?.avatar }>
          <UserCircleIcon fontSize={ style.icon.fontSize } sx={ { color: style.icon.backgroundColor } } />
        </Avatar>
      </Box>
      <AccountMenu
        anchorEl={ anchorRef.current }
        onClose={ handleCloseMenu }
        open={ openMenu }
      />
    </>
  );
};

export default Account;
